import { FormBuilder, Validators } from '@angular/forms';
var RejectionFormComponent = /** @class */ (function () {
    function RejectionFormComponent(formBuilder) {
        this.formBuilder = formBuilder;
        /**
         * Informs if loading is active or not
         */
        this.isLoading = false;
        this.createForm();
    }
    /**
     * Data selection action by clicking the form submit button
     */
    RejectionFormComponent.prototype.doSubmit = function () {
        this.modal.close({
            action: 'save',
            form: 'rejection',
            formData: this.rejectForm.value
        });
    };
    Object.defineProperty(RejectionFormComponent.prototype, "f", {
        /**
         *  Getter to access the form fields
         *
         *  @return AbstractControl
         */
        get: function () {
            return this.rejectForm.controls;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Form creation and validation configuration
     */
    RejectionFormComponent.prototype.createForm = function () {
        this.rejectForm = this.formBuilder.group({
            reason: ['', Validators.required]
        });
    };
    return RejectionFormComponent;
}());
export { RejectionFormComponent };
